import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';
import { isAuthenticated } from '@/lib/auth-store';

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
  },
  component: AppShell,
});
